import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Cake, Gift, Music, Gamepad2, Calendar, Users, Sparkles } from 'lucide-react';

const BookBirthday = () => {
  const [ageGroup, setAgeGroup] = useState('kids');
  const [theme, setTheme] = useState('');

  const themes = [
    { id: 'superhero', name: 'Superhero', icon: '🦸' },
    { id: 'princess', name: 'Princess', icon: '👑' },
    { id: 'disco', name: 'Disco', icon: '🪩' },
    { id: 'sports', name: 'Sports', icon: '⚽' },
    { id: 'jungle', name: 'Jungle Safari', icon: '🦁' },
    { id: 'space', name: 'Space Adventure', icon: '🚀' },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-yellow-50 to-orange-50">
      <Navbar />
      
      <div className="pt-24 pb-20 px-4">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <div className="inline-flex items-center justify-center p-4 bg-gradient-to-r from-yellow-100 to-orange-100 rounded-2xl mb-6">
              <Cake className="h-12 w-12 text-yellow-500" />
              <Gift className="h-10 w-10 text-orange-500 -ml-4" />
            </div>
            <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-yellow-500 to-orange-500 bg-clip-text text-transparent">
              Plan an Amazing Birthday Party
            </h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Make every birthday celebration unforgettable with our creative party planning
            </p>
          </div>

          <div className="bg-white rounded-3xl p-8 shadow-2xl">
            <h2 className="text-3xl font-bold mb-8 text-center text-gray-800">
              Birthday Party Planning
            </h2>
            <form className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-gray-700 mb-2 flex items-center">
                    <Cake className="h-4 w-4 mr-2 text-yellow-500" />
                    Birthday Person's Name
                  </label>
                  <input 
                    type="text" 
                    className="w-full px-4 py-3 rounded-xl border border-yellow-200 focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:border-transparent transition-all" 
                    placeholder="Enter name" 
                  />
                </div>
                <div>
                  <label className="block text-gray-700 mb-2 flex items-center">
                    <Users className="h-4 w-4 mr-2 text-yellow-500" />
                    Age
                  </label>
                  <input 
                    type="number" 
                    className="w-full px-4 py-3 rounded-xl border border-yellow-200 focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:border-transparent transition-all" 
                    placeholder="Enter age" 
                  />
                </div>
                <div>
                  <label className="block text-gray-700 mb-2 flex items-center">
                    <Calendar className="h-4 w-4 mr-2 text-yellow-500" />
                    Birthday Date
                  </label>
                  <input 
                    type="date" 
                    className="w-full px-4 py-3 rounded-xl border border-yellow-200 focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:border-transparent transition-all" 
                  />
                </div>
                <div>
                  <label className="block text-gray-700 mb-2 flex items-center">
                    <Users className="h-4 w-4 mr-2 text-yellow-500" />
                    Number of Guests
                  </label>
                  <input 
                    type="number" 
                    className="w-full px-4 py-3 rounded-xl border border-yellow-200 focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:border-transparent transition-all" 
                    placeholder="Approximate count" 
                  />
                </div>
              </div>

              <div>
                <label className="block text-gray-700 mb-4 text-lg font-semibold">Age Group</label>
                <div className="flex flex-wrap gap-3">
                  {['kids', 'teens', 'adults', 'seniors'].map(group => (
                    <button
                      key={group}
                      type="button"
                      className={`px-6 py-3 rounded-full font-semibold capitalize transition-all duration-300 transform hover:-translate-y-1 ${
                        ageGroup === group 
                          ? 'bg-gradient-to-r from-yellow-400 to-orange-400 text-white shadow-lg' 
                          : 'bg-gray-100 text-gray-700 hover:bg-yellow-50'
                      }`}
                      onClick={() => setAgeGroup(group)}
                    >
                      {group}
                    </button>
                  ))}
                </div>
              </div>

              <div>
                <label className="block text-gray-700 mb-4 text-lg font-semibold">Select Theme</label>
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
                  {themes.map(th => (
                    <div
                      key={th.id}
                      className={`p-4 rounded-2xl text-center cursor-pointer transition-all duration-300 transform hover:-translate-y-1 ${
                        theme === th.id 
                          ? 'bg-gradient-to-b from-yellow-100 to-orange-100 border-2 border-yellow-400 shadow-md' 
                          : 'bg-gray-50 border border-gray-200 hover:border-yellow-300'
                      }`}
                      onClick={() => setTheme(th.id)}
                    >
                      <div className="text-3xl mb-2">{th.icon}</div>
                      <div className="font-medium">{th.name}</div>
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <label className="block text-gray-700 mb-2">Special Requests & Activities</label>
                <textarea 
                  rows="4" 
                  className="w-full px-4 py-3 rounded-xl border border-yellow-200 focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:border-transparent transition-all" 
                  placeholder="Any special requests, activities, entertainment, or specific games needed..."
                ></textarea>
              </div>

              <div>
                <label className="block text-gray-700 mb-4 text-lg font-semibold">Add-ons</label>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <label className="flex items-center space-x-3 p-4 border border-yellow-200 rounded-xl cursor-pointer hover:bg-yellow-50">
                    <input type="checkbox" className="h-5 w-5 text-yellow-500" />
                    <div className="flex items-center">
                      <Gamepad2 className="h-5 w-5 mr-2 text-yellow-500" />
                      <span>Game Station</span>
                    </div>
                  </label>
                  <label className="flex items-center space-x-3 p-4 border border-yellow-200 rounded-xl cursor-pointer hover:bg-yellow-50">
                    <input type="checkbox" className="h-5 w-5 text-yellow-500" />
                    <div className="flex items-center">
                      <Music className="h-5 w-5 mr-2 text-yellow-500" />
                      <span>DJ/Live Music</span>
                    </div>
                  </label>
                  <label className="flex items-center space-x-3 p-4 border border-yellow-200 rounded-xl cursor-pointer hover:bg-yellow-50">
                    <input type="checkbox" className="h-5 w-5 text-yellow-500" />
                    <div className="flex items-center">
                      <Cake className="h-5 w-5 mr-2 text-yellow-500" />
                      <span>Custom Birthday Cake</span>
                    </div>
                  </label>
                  <label className="flex items-center space-x-3 p-4 border border-yellow-200 rounded-xl cursor-pointer hover:bg-yellow-50">
                    <input type="checkbox" className="h-5 w-5 text-yellow-500" />
                    <div className="flex items-center">
                      <Sparkles className="h-5 w-5 mr-2 text-yellow-500" />
                      <span>Magician/Entertainer</span>
                    </div>
                  </label>
                </div>
              </div>

              <button 
                type="submit" 
                className="w-full py-4 bg-gradient-to-r from-yellow-400 to-orange-400 text-white font-bold text-xl rounded-xl hover:shadow-xl hover:shadow-yellow-200 transform hover:-translate-y-1 transition-all duration-300"
              >
                Plan This Birthday Party
              </button>
            </form>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default BookBirthday;